const pricingData = [
    {
        title: 'Starter Pack',
        icon: 'fe-at-sign',
        price: '$9 ',
        storage: 5,
        bandwidth: '250 GB Bandwidth',
        domain: 'No Domain',
        user: '1 User'
    },
    {
        title: 'Professional Pack',
        icon: 'fe-users',
        price: '$19 ',
        storage: 50,
        bandwidth: '500 GB Bandwidth',
        domain: 'No Domain',
        user: '1 User'
    },
    {
        title: 'Business Pack',
        icon: 'fe-award',
        price: '$29 ',
        storage: 50,
        bandwidth: '900 GB Bandwidth',
        domain: '2 Domain',
        user: '10 User',
        ribbon: 'Popular'
    },
    {
        title: 'Enterprise Pack',
        icon: 'fe-aperture',
        price: '$39 ',
        storage: 100,
        bandwidth: 'Unlimited Bandwidth',
        domain: '10 Domain',
        user: 'Unlimited User'
    }
];

export { pricingData };
